import React, { memo, useEffect, useState } from 'react'
import { required, useTranslate, useNotify } from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { getSupplierByProduct } from 'src/components/pages/sales/reservation/helper/getSupplierByProduct'
import { orderSuppliers } from '../../helper/sortSuppliersFunction.js'

export const GetOtherProductFields = memo(({ record, product }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [provider, setProvider] = useState([])
  const [loadingProvider, setLoadingProvider] = useState([])

  useEffect(() => {
    if (product && product?.product_type_id) {
      const data = {
        product: {
          product_type_id: product?.product_type_id,
        },
      }
      getSupplier(data)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product])

  const getSupplier = async (product) => {
    try {
      setLoadingProvider(true)
      const providers = await getSupplierByProduct(product)
      if (providers) {
        setProvider(providers)
      }
    } catch (error) {
      notify('ra.message.supplier_error', { type: 'error' })
    } finally {
      setLoadingProvider(false)
    }
  }

  return (
    <Grid container spacing={2}>
      <EditInputsWrap label={translate('ra.field.supplier')} required>
        {loadingProvider ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='other.supplier'
            options={orderSuppliers(provider || [], record?.other?.supplier?.include ?? [])}
            label=''
            optionsText={['name']}
            optionValue='code'
            size='small'
            showAllOption
            showSearch
            multiple
            defaultValue={record ? record?.other?.supplier : undefined}
            validate={[required()]}
          />
        )}
      </EditInputsWrap>
    </Grid>
  )
})
